import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

class Header extends Component {
  constructor(props) {
    super(props);
    this.goToDashboard = this.goToDashboard.bind(this);
    this.goToProfile = this.goToProfile.bind(this);
    this.goToNots = this.goToNots.bind(this);
    this.goToMsg = this.goToMsg.bind(this);
  }

  goToDashboard() {
    window.open('https://www.d-cot.com/dashboard/');
    return false;
  }

  goToProfile() {https://www.d-cot.com/steve/notifications/
    window.open('https://www.d-cot.com/'+this.props.username+'/');
    return false;
  }

  goToNots() {
    window.open('https://www.d-cot.com/'+this.props.username+'/notifications/');
    return false;
  }

  goToMsg() {
    window.open('https://www.d-cot.com/'+this.props.username+'/messages/');
    return false;
  }

  render() {
    return (
      <div>
        <header id="site-header">
          <div className="container-fluid">
            <div className="row">
              <div className="col">
                <nav className="navbar navbar-expand navbar-dark fixed-top bg-dark">
                  <NavLink exact className="navbar-brand mr-5" to="/"><img className="logo-dcot img-fluid" src="https://data.d-cot.com/assets/logo-dcot.png" srcSet="https://data.d-cot.com/assets/logo-dcot.png 1x, https://data.d-cot.com/assets/logo-dcot@2x.png 2x" alt="D-COT logo" /></NavLink>
                  <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#site-navbar" aria-controls="site-navbar" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                  </button>

                  <div className="collapse navbar-collapse" id="site-navbar">
                    <div className="mr-auto"></div>

                    <a className="sponsor" href="http://offtoneverland.com/?cpe=Y3A9R2VuZXJhbCtMaW5rJnM9RC1Db1Q%3D" target="_blank" rel="noopener noreferrer">
                      <img className="img-fluid" alt="Off to Neverland Travel" src="https://jukebox.d-cot.com/static/media/offtoneverland.0281f8ca.jpg" />
                    </a>

                    <ul className="navbar-nav ml-auto">
                      <li className="nav-item">
                        <NavLink exact className="nav-link" role="button" to="/"><i className="fa fa-music" aria-hidden="true"></i> <span>Jukebox</span></NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink exact className="nav-link" role="button" to="/catalog/"><i className="fa fa-search" aria-hidden="true"></i> <span>Catalog</span></NavLink>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link" target="_blank" href="https://www.d-cot.com/forums/" rel="noopener nofollow"><i className="fa fa-comments" aria-hidden="true"></i> <span>Forums</span></a>
                      </li>
                      <li className="nav-item dropdown">
                        <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-expanded="false">
                          <img src={this.props.avatar} alt="Profile picture" width="32" />
                        </a>
                        <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                          <a className="dropdown-item" onClick={this.goToDashboard} rel="noopener nofollow"><i className="fa fa-tachometer" aria-hidden="true"></i> Dashboard</a>
                          <a className="dropdown-item" onClick={this.goToProfile} rel="noopener nofollow"><i className="fa fa-user pr-1" aria-hidden="true"></i> Profile</a>
                          <a className="dropdown-item" onClick={this.goToNots} rel="noopener nofollow"><i className="fa fa-bell" aria-hidden="true"></i> Notifications</a>
                          <a className="dropdown-item" onClick={this.goToMsg} rel="noopener nofollow"><i className="fa fa-comments" aria-hidden="true"></i> Messages</a>
                          <NavLink exact className="dropdown-item" to="/logout/"><i className="fa fa-sign-out" aria-hidden="true"></i> <span>Logout</span></NavLink>
                        </div>
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </header>
      </div>
    );
  }
}

export default Header;
